import { createFileRoute } from '@tanstack/react-router';
import { CatalogoInsumosView } from '@/modules/agronomia/components/CatalogoInsumosView';

// Tela 01 · Catálogo de Insumos — destino do pipe "Catálogo de insumos" da
// seleção do módulo Agronomia (desktop).
export const Route = createFileRoute('/_authed/agronomia_/insumos')({
  component: CatalogoInsumosView,
});
